module.exports = __webpack_public_path__ + "images/emoji/mens.a5d77e2e1cfb5a5b0946.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mens.png
// module id = bJzV
// module chunks = 1